import * as React from 'react';
import { Container, ContainerType, Subscribe } from 'unstated';

const withContainer =
  (container: ContainerType<any>, propName: string = 'container') =>
  (WrappedComponent: React.ComponentType<any>) => {
    return class extends React.Component {
      render() {
        return (
          <Subscribe to={[container]}>
            {container =>
              React.createElement(WrappedComponent, {
                [propName]: container,
                ...this.props
              })
            }
          </Subscribe>
        );
      }
    };
  };

const withContainers =
  (containers: Record<string, ContainerType<any>>) =>
  (WrappedComponent: React.ComponentType<any>) => {
    return class extends React.Component {
      render() {
        return (
          <Subscribe to={Object.values(containers)}>
            {(...injectedContainers) => {
              const props = Object.keys(containers).reduce(
                (acc, key, index) => {
                  acc[key] = injectedContainers[index];
                  return acc;
                },
                {} as Record<string, Container<any>>
              );

              return React.createElement(WrappedComponent, {
                ...props,
                ...this.props
              });
            }}
          </Subscribe>
        );
      }
    };
  };

export default withContainer;
export { withContainers };
